import { css } from 'styled-components';

const scrollAreaStyles = css([
  `&::-webkit-scrollbar{width:0.5rem;height:0.5rem;}&::-webkit-scrollbar-thumb{background:rgb(146 146 146 / 30%);border-radius:1.5rem;visibility:hidden;}&:hover::-webkit-scrollbar-thumb{visibility:visible;}&::-webkit-scrollbar-thumb:active,&::-webkit-scrollbar-thumb:hover{background-color:rgb(146 146 146 / 40%);visibility:visible;}&::-webkit-scrollbar-track{background:rgb(0 0 0 / 7%);border-radius:1.5rem;visibility:hidden;}&:hover::-webkit-scrollbar-track{visibility:visible;}&::-webkit-scrollbar-corner{background-color:transparent;}@media (max-width:768px){&::-webkit-scrollbar{width:0;height:0;}&{scrollbar-width:none;}}`
]);

export { scrollAreaStyles };
//# sourceMappingURL=scrollarea.js.map
